/**
 * @file: 分销2.0 推广详情
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/05/09      2.0     Second version
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */

import React  from "react";
import {Spin, Tabs, Popover,  message, Avatar, Modal, Form, Input} from 'antd';
import dayjs from 'dayjs';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import AutoFetchTable from "@components/AutoFetchTable/AutoFetchTable";
import {formatNumberToPrice, isEmpty, toFixed2} from "@utils/utils";
import Lang from "@/components/Lang/Lang";
import qs from 'qs';
import "./Index.less";
import DistributorAction from "../Distributor.action";

class DistributionCenterRecommend extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bindVisible:false,
            loading: false,
            sTypeFrom:'',// 来源页面:提成分销新增将传入 typefrom=orderCommission
            model: {},
            detail:{},
            columns:[
                {
                    cnTitle:'注册时间',
                    dataIndex: 'registerTime',
                    cnTitleId: 'ZhuCeShiJian',
                    render: (startTime, record) => startTime?dayjs(startTime).format('YYYY-MM-DD HH:mm:ss'):'-'
                },
                {
                    cnTitle:'客户编号',
                    dataIndex: 'buyerCode',
                    cnTitleId: 'KeHuBianHao',
                },
                {
                    dataIndex: 'isTargetCustomer',
                    cnTitle:'是否目标客户',
                    cnTitleId: 'ShiFouMuBiaoKeHu',
                    // type:"Enum",
                    // enumClass:'fx_invitation_buyer_status',
                    render: (type, record) => {
                        const list = __getDictMap('fx_invitation_buyer_status')||[];
                        // 0:认证中 1:认证失败 2:已认证
                        return <div className={"flex-item-ver-center"}>
                         {<span>
                            {type == 1 ?Lang({id:"Shi",default:'是'}):Lang({id:"Fou",default:'否'})}
                          </span>}
                            {/* <span className={type==0?'orange':(type==2?'green':'red')}>{!isEmpty(type)?list[type]:''}</span>
                            {type==1&& <Popover content={record.statusReason} placement="top" trigger="hover">
                                <div>
                                    <span className="iconfont icon-q margin-left-5"></span>
                                </div>
                            </Popover>} */}
                        </div>
                    }
                },
                {
                    cnTitle:'提成',
                    dataIndex: 'commission',
                    cnTitleId: 'TiCheng',
                    render: ( num = {}, record) =>  {
                        // 0:认证中 1:认证失败 2:已认证
                        return <span className={record.buyerStatus=='1'?'font-line-through color-secondary-grey':(record.buyerStatus=='2'?'color-grey':'color-secondary-grey')}>{record.currencySymbol}
                            <span className={"margin-left-5"}>{formatNumberToPrice(toFixed2(num||0),',',true)}</span>
                            {record.buyerStatus=='2'&&<span className={'iconfont icon-gou icon-green'}></span>}
                       </span>
                    }
                },
            ],
            searchFormOptionsOne:[
                {
                    name:'buyerStatus',//'采购商认证状态',
                    cnTitleId:'CaiGouShangRenZhengZhuangTai',
                    cnPlaceholderId:'QuanBu',
                    cnPlaceholder:'全部',
                    type:'Enum',
                    enumClass:'fx_invitation_buyer_status',
                    hiddenLabel:true,
                    allowClear:true,
                    canSearch:true,
                    enumCanAll:true,
                },
            ],
            columnsTwo:[
                {
                    dataIndex: 'createTime',
                    cnTitle:'创建时间',
                    cnTitleId:'ChuangJianShiJian',
                    render:(text, record, index) => (<div>
                        <p>{record.createTime?dayjs(record.createTime).format("YYYY-MM-DD HH:mm:ss"):'-'}</p>
                    </div>),
                },
                {
                    dataIndex: 'mobile',
                    cnTitle:'手机号码',
                    cnTitleId: 'ShouJiHaoMao',
                    render:(text, record, index) => (<div>
                        <a href={'/distributor/detail?'+record.distributorUserId} target={"_blank"}>{text}</a>
                    </div>),
                },
                {
                    dataIndex: 'name',
                    cnTitle:'姓名',
                    cnTitleId: 'XingMing',
                },
                {
                    dataIndex: 'invitationBuyerTotal',
                    cnTitle:'邀请客户数',
                    cnTitleId: 'YaoQingKeHuShu',
                },
                {
                    dataIndex: 'commissionTotal',
                    title: (<div className={"flex-item-ver-center"}>{Lang({id:"LeiJiJiangLi",default:'累计奖励'})}<Popover content={Lang({id:"FenXiaoShangChengGongYaoQingKeHuLeiJiJiangLiTiShi2",default:'分销商成功邀请客户，他累计获得的提成。'})} placement="top" trigger="hover">
                        <span className="iconfont icon-q margin-left-5 light-grey"></span>
                    </Popover></div>),
                    // cnTitle:'累计奖励',
                    // cnTitleId: 'LeiJiJiangLi',
                    type:"money",
                    showSymbol:'currencySymbol',
                },
                {
                    dataIndex: 'isTargetCustomer',
                    cnTitle:'是否目标客户',
                    cnTitleId: 'ShiFouMuBiaoKeHu',
                    // type:"Enum",
                    // enumClass:'fx_user_status',
                    render: (type, record) => {
                        const list = __getDictMap('fx_user_status')||[];
                        //  NOT_ENABLED:未激活 VALID:启用 INVALID:禁用
                        return <div className={"flex-item-ver-center"}>
                            {/* <span className={type=='NOT_ENABLED'?'orange':(type=='VALID'?'green':'red')}>{!isEmpty(type)?list[type]:''}</span> */}
                            {type == 1 ?Lang({id:"Shi",default:'是'}):Lang({id:"Fou",default:'否'})}
                        </div>
                    }
                },
            ],
            tabStatus:'1',//默认 1:邀请的客户 2:下级分销商
            currencySymbol : '',
            roleUserId:"",
        }
    }
    bindRef = React.createRef();
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }

    /**
     * 改变状态
     **/
    changeTab(activeKey){
        this.setState({
            tabStatus:activeKey
        },()=>{
            switch (activeKey) {
                case '2':
                    if(this.onRefTabChildTwo){
                        this.onRefTabChildTwo.handleFetch()
                    }
                    break
                default:
                    if(this.onRefTabChildOne){
                        this.onRefTabChildOne.handleFetch()
                    }
            }
        })
    }
    // 查询结果回调
    fetchCallBack(res){
        const {success,valid,model} = res;
        if (success && valid) {
            this.setState({
                model:model||{}
            })
        }else this.setState({
            model: {}
        })
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    onRefTabTwo = (ref) =>  this.onRefTabChildTwo = ref;
    // 设置 当前
    getUser(iId){
        this.setState({
            roleUserId: iId
        })
        const postData={
            id: iId
        }
        DistributorAction.getDistributor(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
    }
    handleRes(res){
        this.loading(false);
        const {success,valid,model} = res;
        if(success&&valid){
           this.setState({
               detail:model
           })
        }else if(res.message)message.warning(res.message);
    }
    //跳转
    goPage(sUrl) {
        this.props.history.push(sUrl);
    }


    handleOk = () => {
        const { validateFields } = this.bindRef.current;
        var that = this;
        let {roleUserId} = this.state;
        validateFields().then((values) => {
            const { buyerCode } = values;
            DistributorAction.bindBuyer({
                id:roleUserId,
                buyerCode:buyerCode
            }).then(res => {
                if(res.data.success && res.data.valid){
                    that.setState({
                        bindVisible:false
                    },()=>{
                        message.success(Lang({ id: "BangDingChengGong", default: "绑定成功" }))
                    })

                }else{
                    message.error(Lang({ id: "ChaXunBuDaoKeHuBianHao", default: "查询不到客户编号" }))
                }
            })

        })
    }

    init(){
        const { search } = this.props.location;
        const list = qs.parse(search)||{};
        const sType =list['typefrom']
        if(!isEmpty(sType)){
            this.setState({
                sTypeFrom:sType,
            })
        }
        this.getUser(list['?id'])
    }
    bindFn () {
        // let {detail} = this.state;
        // if(!detail.isApplyEssaonePlatform){
        //     message.error(Lang({ id: "FeiKeHuBuNengBangDing", default: "非ESSAONE客户不能绑定" }))
        //     return;
        // }
        this.setState({
            bindVisible:true
        })
    }
    componentWillMount() {
        this.init()
        // this.getUser()
    }
    componentDidMount() {
        const { tabStatus} = this.state;
        if( tabStatus =='2')if(this.onRefTabChildTwo)this.onRefTabChildTwo.handleFetch()
    }

    render() {
        const { loading,model,detail,columns,searchFormOptionsOne,tabStatus,currencySymbol,columnsTwo,roleUserId,sTypeFrom,bindVisible} = this.state;
        const iconUrl = detail.abbreviate?require('../../../assets/img/country/'+detail.abbreviate + '.png'):'';
        // 默认 注册分销，传入typefrom=orderCommission 即为提成分销
        const currPageName = sTypeFrom=='orderCommission'?Lang({id: "TiChengFenXiaoShang",default: "提成分销商"}):Lang({id: "ZhuCeFenXiaoShang",default: "注册分销商"});
        // 累计邀请  人，已认证通过 {model.authUserTotal||0}人，获得提成{currencySymbol}{model.commissionTotal||0}
        const setRight =(<div className={'textRight'}
                              dangerouslySetInnerHTML={{__html: __getServerLanguage('LeiJiYaoQingRenYiRenZhengTongGuoRenHuoDeTiCheng',
                                      `<span>${model.invitationUserTotal||0}</span>`,
                                      `<span>${model.authUserTotal||0}</span>`,
                                      `<span>${currencySymbol}<span class="margin-left-5">${model.commissionTotal||0}</span></span>`)}}></div>)
        return (<Spin spinning={loading}>
            <div className="distribution-recommend-page">
                <CommonBreadcrumb list={[
                    { name:currPageName,link:sTypeFrom=='orderCommission'?"/distributor/extractDistributionList":'/distributor/list'},
                    {name:detail&&detail.accountName?detail.accountName:''}]}></CommonBreadcrumb>
                <h2>{Lang({id: 'FenXiaoShangTuiGuangXiangQing',default:'分销商推广详情'})}</h2>
                <div className={"info-detail flex-item-ver-center"}>
                    <Avatar size={48} src={iconUrl?iconUrl.default:''} title={detail.name} />
                    <div className={'info'}>
                        <p className={'info-account'}>{detail.accountName}</p>
                        <p><span className={"name"}>{detail.name}</span></p>
                    </div>
                    <div className={'info-digital flex-item-ver-center'}>
                        <div className={"info-digital-box"}>
                            <p>{Lang({id: 'TuiGuangKeHuShu',default:'推广客户数'})}</p>
                            <div className={"num"}>{detail.buyerCount}</div>
                        </div>
                        <div className={"info-digital-box"}>
                            <p>{Lang({id: 'XiaJiFenXiaoShang',default:'下级分销商'})}</p>
                            <div className={"num"}>{detail.twoLevelUserCount}</div>
                        </div>
                        <div className={"info-digital-box"}>
                            <p>{Lang({id: 'XiaJiTuiGuangKeHu',default:'下级推广客户'})}</p>
                            <div className={"num"}>{detail.twoLevelUserBuyerCount}</div>
                        </div>
                    </div>
                </div>
                <div className={"info-detail flex-item-ver-center margin-0"}>
                    <div className={'info'}>
                        <p className={'info-account'}><a className={'btn'} onClick={()=>this.goPage('/distributor/edit?id='+roleUserId+(sTypeFrom?'&typefrom='+sTypeFrom:''))}>{Lang({id: 'BianJiZiLiao',default:'编辑资料'})}</a></p>
                    </div>
                    <div className={'info invite'}>
                        <p className={'info-account'}><a className={'btn'} onClick={()=>{
                            this.bindFn()

                        }}>{Lang({id: 'BangDingYaoQingKeHu',default:'绑定邀请客户'})}</a></p>
                    </div>
                </div>

                    <Modal
                        title={Lang({ id: "BangDingKeHu" ,default:'绑定客户'})}
                        open={bindVisible}
                        onOk={this.handleOk}
                        onCancel={() => {
                            this.setState({
                                bindVisible:false
                            })
                        }}
                    >
                        <Form
                            name="bindForm"
                            ref={this.bindRef}
                        >
                            <p style={{lineHeight:'30px'}}>{Lang({id: 'BangDingKeHuDaoGaiFenXiaoShangMingXia',default:'绑定客户到该分销商名下，此操作将改变客户原有的绑定关系'})}</p>
                            <Form.Item
                                name="buyerCode"
                                rules={[
                                    {
                                        required: true,
                                        message: Lang({
                                            id: "QingShuRuKeHuBianHao",
                                            children: "请输入客户编号",
                                        }),
                                    },
                                ]}
                            >
                                <Input
                                    placeholder={Lang({
                                        id: "QingShuRuKeHuBianHao",
                                        children: "请输入客户编号",
                                    })}
                                />
                            </Form.Item>
                        </Form>
                    </Modal>


                <div className={"main"}>
                    {/*  表格 */}
                    <Tabs defaultActiveKey={tabStatus}
                          items={[
                              {
                                  key: '1',
                                  label:Lang({id: 'YaoQingDeKeHu',default:'邀请的客户'}),
                                  children:(<div className={'content'}>
                                      {/*下级分销商*/}
                                      {roleUserId&&<AutoFetchTable columns={columns}
                                                                   onRef={this.onRefTabOne}
                                                                   searchFormOptions={searchFormOptionsOne}
                                                                   topSearchRightCont={setRight}
                                                                   precondition={{
                                                                       distributorUserId :roleUserId,
                                                                   }}
                                                                   partRow={3}
                                                                   flagShowReset={false}
                                                                   flagShowSearchBtn={false}
                                                                   fetchCallBack={(res)=>this.fetchCallBack(res)}
                                                                   fetchApi={'/service/fenxiao/center/my-invitation-list'} />}
                                  </div>)
                              },{
                                  key: '2',
                                  label:Lang({id: 'XiaJiFenXiaoShang',default:'下级分销商'}),
                                  children:(<div className={'content'}>
                                      {/*邀请的客户*/}
                                      {roleUserId&&<AutoFetchTable columns={columnsTwo}
                                                                   onRef={this.onRefTabTwo}
                                                                   topSearchRightCont={setRight}
                                                                   precondition={{
                                                                       distributorUserId : roleUserId,
                                                                   }}
                                                                   flagShowReset={false}
                                                                   flagShowSearchBtn={false}
                                                                   showQuickJumper={false}
                                                                   fetchCallBack={(res)=>this.fetchCallBack(res)}
                                                                   fetchApi={'/service/fenxiao/center/two-level-invitation-list'} />}
                                  </div>)
                              }
                          ]}
                          onChange={(activeKey)=>this.changeTab(activeKey)}>
                    </Tabs>
                    {/*  表格 end*/}
                </div>
            </div>
        </Spin>);
    }
}
export default DistributionCenterRecommend;